import React from 'react'
import PillList from 'elements/PillList'
import i18n, {catIdToString} from 'lib/i18n'
const _ = i18n()

const CategoriesList = ({categoryIds, customStyle}) => {
	return (
		<PillList
			customStyle={customStyle}
			noPills={_('emptyCategories')}
			title={_('keywords')}
		>
			{categoryIds.map(catIdToString)}
		</PillList>
	)
}

export default CategoriesList



// WEBPACK FOOTER //
// ./elements/CategoriesList.jsx